import { createFileRoute, useParams } from '@tanstack/react-router'
import { ThematicDefinitionsPage } from '../../../../components/thematics/ThematicDefinitionsPage'

export const Route = createFileRoute('/$org/types/thematics/')({
  component: ThematicsRoute,
})

function ThematicsRoute() {
  const { org } = useParams({ from: '/$org/types/thematics/' })
  return <ThematicDefinitionsPage org={org} />
}
